<div class="div-box-margin" fxLayout="column" fxLayoutAlign="center center">
  <mat-checkbox [(ngModel)]="CheckBoxUserVal" (change)="checkBoxChange($event)">
    <div class="word-break, thinner-line" style="margin-left: 5px;" >{{Title}}</div>
  </mat-checkbox>
  <!-- <mat-icon *ngIf="Dirty" class="button aro-label" style="font-size: 15px;" (click)="BackToLiveValue()">keyboard_return</mat-icon> -->
  <!-- <div class="aro-label"> {{'FIELDS.CURRENT_VALUE' | translate}}: {{RealValue ? ('FIELDS.CHECKED' | translate) : ('FIELDS.UNCHECKED' | translate)}}</div> -->
</div>